import React from 'react'
import Card from '@mui/material/Card';

import { Divider } from '@mui/material';

const Terms = () => {
    return (
        <>
            <Card>
                <div className='p-3 text-center'>
                    <h3> TERM AND CONDITIONS </h3>
                </div>
            </Card>
            <Divider />
            <Card>
                <div className="row">

                    <div className='col-md-12 p-4 m-2 px-5'>
                        <div>
                            <strong>

                                INTRODUCTION
                            </strong>
                        </div>
                        <p>

                            These terms and conditions govern your use of this website; by using this website, you accept these terms and conditions in full. If you disagree with these terms and conditions or any part of these terms and conditions, you must not use this website.
                        </p>

                        <div>
                            <strong>

                                LICENSE TO USE WEBSITE
                            </strong>
                        </div>

                        <p>

                            Unless otherwise stated, ISSRA Publishers and/or its licensors own the intellectual property rights in the website and material on the website.  Subject to the license below, all these intellectual property rights are reserved.
                        </p>

                        <p>

                            You may view, download for caching purposes only, and print pages from the website for your own personal use, subject to the restrictions set out below and elsewhere in these terms and conditions.
                        </p>

                        <p>

                            You must not:
                            <br />
                            •	Republish material from this website (including republication on another website);
                            <br />
                            •	Sell, rent or sub-license material from the website;
                            <br />
                            •	Show any material from the website in public;
                            <br />
                            •	Reproduce, duplicate, copy or otherwise exploit material on this website for a commercial purpose;
                            <br />
                            •	Edit or otherwise modify any material on the website; or
                            <br />
                            •	Redistribute material from this website except for content specifically and expressly made available for redistribution.
                        </p>

                        <p>

                            You may reproduce, duplicate, copy, edit, modify and redistribute content that is specifically made available under the terms of the Creative Commons Attribution License 4.0 International License. However, you may not claim ownership or pretend to be the content owner by republishing without adequate citation and credit with links to the original source of the content.
                        </p>

                        <div>
                            <strong>

                                ACCEPTABLE USE
                            </strong>
                        </div>
                        <p>

                            You must not use this website in any way that causes, or may cause, damage to the website or impairment of the availability or accessibility of the website; or in any way which is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity.
                        </p>

                        <p>

                            You must not use this website to copy, store, host, transmit, send, use, publish or distribute any material which consists of (or is linked to) any spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit or other malicious computer software.
                        </p>

                        <div>
                            <strong>

                                USER CONTENT
                            </strong>
                        </div>
                        <p>

                            In these terms and conditions, “your user content” means material (including without limitation text, images, audio material, video material and audio-visual material) that you submit to this website, for whatever purpose.
                        </p>

                        <p>

                            You grant to ISSRA Publishers a worldwide, irrevocable, non-exclusive, royalty-free license to use, reproduce, adapt, publish, translate and distribute your user content in any existing or future media.
                        </p>

                        <p>

                            Your user content must not be illegal or unlawful, must not infringe any third party's legal rights, and must not be capable of giving rise to legal action whether against you or ISSRA Publishers or a third party (in each case under any applicable law).
                        </p>

                        <p>

                            You must not submit any user content to the website that is or has ever been the subject of any threatened or actual legal proceedings or other similar complaint.
                        </p>

                        <p>

                            ISSRA Publishers reserves the right to edit or remove any material submitted to this website.
                        </p>

                        <div>
                            <strong>

                                NO WARRANTIES
                            </strong>
                        </div>
                        <p>

                            This website is provided “as is” without any representations or warranties, express or implied.  ISSRA Publishers makes no representations or warranties in relation to this website or the information and materials provided on this website.
                        </p>

                        <p>

                            Without prejudice to the generality of the foregoing paragraph, ISSRA Publishers does not warrant that:
                            <br />
                            •	This website will be constantly available, or available at all; or
                            <br />
                            •	The information on this website is complete, true, accurate or non-misleading. Nothing on this website constitutes, or is meant to constitute, advice of any kind.
                        </p>

                        <div>
                            <strong>

                                LIMITATIONS OF LIABILITY
                            </strong>
                        </div>
                        <p>

                            ISSRA Publishers will not be liable to you (whether under the law of contact, the law of torts or otherwise) in relation to the contents of, or use of, or otherwise in connection with, this website.
                        </p>

                        <div>
                            <strong>

                                REASONABLENESS
                            </strong>
                        </div>
                        <p>

                            By using this website, you agree that the exclusions and limitations of liability set out in these terms and conditions are reasonable.
                        </p>

                        <p>

                            If you do not think they are reasonable, you must not use this website.
                        </p>

                        <div>
                            <strong>
                                OTHER PARTIES
                            </strong>
                        </div>
                        <p>

                            You accept that, as a limited liability entity, ISSRA Publishers has an interest in limiting the personal liability of its officers and employees.  You agree that you will not bring any claim personally against ISSRA Publishers officers or employees in respect of any losses you suffer in connection with the website.
                        </p>

                        <p>

                            You agree that the limitations of warranties and liability set out in this website disclaimer will protect ISSRA Publishers officers, employees, agents, subsidiaries, successors, assigns and sub-contractors as well as ISSRA Publishers.
                        </p>

                        <div>
                            <strong>

                                INDEMNITY
                            </strong>
                        </div>
                        <p>

                            You hereby indemnify ISSRA Publishers and undertake to keep ISSRA Publishers indemnified against any losses, damages, costs, liabilities and expenses (including without limitation legal expenses and any amounts paid by ISSRA Publishers to a third party in settlement of a claim or dispute on the advice of ISSRA Publishers legal advisers) incurred or suffered by ISSRA Publishers arising out of any breach by you of any provision of these terms and conditions.
                        </p>

                        <div>
                            <strong>

                                BREACHES OF THESE TERMS AND CONDITIONS
                            </strong>
                        </div>
                        <p>

                            Without prejudice to ISSRA Publishers' other rights under these terms and conditions, if you breach these terms and conditions in any way, ISSRA Publishers may take such action as ISSRA Publishers deems appropriate to deal with the breach.
                        </p>

                        <div>
                            <strong>

                                VARIATION
                            </strong>
                        </div>
                        <p>

                            ISSRA Publishers may revise these terms and conditions from time-to-time.  Revised terms and conditions will apply to the use of this website from the date of the publication of the revised terms and conditions on this website.  Please check this page regularly to ensure you are familiar with the current version.
                        </p>


                    </div>
                </div>
            </Card>
            <br />
        </>
    )
}

export default Terms